

export class ExpenseStatusInput implements IExpenseStatusInput {
    /** The auto-generated id of the expense master */
    expenseId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IExpenseStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseId = _data["expenseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExpenseStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseId"] = this.expenseId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExpenseStatusInput {
    /** The auto-generated id of the expense master */
    expenseId: number;
    /** The updated status */
    status: number;
}

